import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "@/data/AuthProvider";
import { AppRoutes } from "./routes";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // CoinGecko's free tier rate-limits aggressively — six requests in
      // twenty seconds was enough to trigger 429 during Phase 0 probing.
      // Cache hard and do not refetch on every window focus.
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
